import Cookies from 'universal-cookie';
import { COOKIE_I18N_LANG } from '@bridebook/web/app-shared/lib/i18n/cookies';

export const getCookieLocale = () => {
  const cookies = new Cookies();
  const cookieLocale = cookies.get(COOKIE_I18N_LANG);
  return cookieLocale as string | undefined;
};
